'use strict';

import React from 'react';
import PubSub from 'pubsub-js';


class Btn extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      statusText: "START",
      baseFrequency: .01,
      animeDirection: "up"
    }

    this._onClick = this._onClick.bind(this);
    this._animateButton = this._animateButton.bind(this);
    this.start = this.start.bind(this);
    this.loop = this.loop.bind(this);
    this.stop = this.stop.bind(this);
  }

  componentWillMount(){
    
    // console.log("componentWillMount")
    // console.log(this.turb)
  }

  componentDidMount(){
    this.turb = document.querySelectorAll('#filter feTurbulence')[0];
    //this.turb.setAttribute('baseFrequency', .0001 + ' ' + .15);
    PubSub.subscribe('STATUS', (e,d) => {
      //console.log(d)
      if(d.type == "TELEPORT_DONE"){
        this.setState({
          statusText: "TELEPORT"
        })
      }
    })
  }

  _onClick(e){
    if(this.state.statusText == "START"){
      this._geoloc();
    }else{
      this._changeSpot();
    }
  }

  _animateButton(){
    this.start();
  }

  start() {
    if( !this._frameId ) {
        this._frameId = window.requestAnimationFrame( this.loop );
      }
  }

  loop(time) {
    let {baseFrequency, animeDirection} = this.state
    let incrementer = .01;

    if(baseFrequency < 0.15 && animeDirection == "up"){
      this.setState({
        animeDirection: "up",
        baseFrequency: baseFrequency + incrementer
      })
    }else{
      //incrementer -= incrementer
      if(baseFrequency > .01){
        this.setState({
          animeDirection: "down",
          baseFrequency: baseFrequency - incrementer
        })  
      }else{
        this.setState({
          animeDirection: "up",
          baseFrequency: 0
        }) 
      }
    }    

    //console.log(baseFrequency, animeDirection)
    this.turb.setAttribute('baseFrequency', .0001 + ' ' + this.state.baseFrequency);

    if(baseFrequency <= 0){
      //console.log("stop")
      this.stop();
    }else{
      //console.log("play")
      this._frameId = window.requestAnimationFrame( this.loop )
    }
  }

  stop() {
    if( this._frameId ){
      window.cancelAnimationFrame( this._frameId );
      this._frameId = undefined;
      this.turb.setAttribute('baseFrequency', 0.0001 + ' ' + .0001);
    }
  }

  map(value, start1, stop1, start2, stop2) {
    return start2 + (stop2 - start2) * ((value - start1) / (stop1 - start1));
  }
  _geoloc(){
    //console.log("_geoloc")
    PubSub.publish('STATUS', {
      type: 'GEOLOC...'
    });

    try {
      //if (navigator.geolocation) {
      //console.log(navigator)
      navigator.geolocation.getCurrentPosition( (position) => {
        //console.log(position)
        PubSub.publish('STATUS', {
          type: 'INITIALIZE',
          data: [position.coords.latitude, position.coords.longitude]
        });
      },  (error) => {
        if (error.code == error.PERMISSION_DENIED){
            console.log("you denied me :-(");
            PubSub.publish('STATUS', {
              type: 'TELEPORT_FALLBACK'
            });
        }
      });
      // } else {
      //     this.geolocFallBack();
      // }
    } catch(err) {
      console.log(err);
      PubSub.publish('STATUS', {
        type: 'TELEPORT_FALLBACK'
      });
    }
  }

  _changeSpot(){
    const {spots} = this.props;

    if(spots.length == 0)
      initSpots();
    else{
      var rand = Math.round(Math.random() * (spots.length-1));
      var _spots = spots;
      _spots.splice(rand, 1);

      //console.log("SPOTS.length",_spots.length)
      //this.teleport();
      PubSub.publish('STATUS', {
        type: 'TELEPORT', 
        data: [spots[rand][0], spots[rand][1]]
      });
    }
  }

  render() {

  	return (
      <div className="btn-component">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" className="svg-filters">
          <defs>
            <filter id="filter">
              <feTurbulence type="fractalNoise" baseFrequency="0.00" numOctaves="1" result="warp"></feTurbulence>
              <feDisplacementMap xChannelSelector="R" yChannelSelector="G" scale="30" in="SourceGraphic" in2="warp" />
            </filter>
          </defs>
        </svg>
        <button 
        type="button" 
        className="button"
        onMouseUp={this._onClick}
        onMouseOver={this._animateButton}>{this.state.statusText}</button>
      </div>
      );
  }
}

Btn.displayName = 'Btn';

// Uncomment properties you need
// BtnComponent.propTypes = {};
// BtnComponent.defaultProps = {};

export default Btn;



// WEBPACK FOOTER //
// ./src/components/Btn.js